/* =====================================================
   Luxury Categories — interactions
   - Stagger fade-up reveal on scroll
   - Pointer-tracking ambient glow (desktop, fine pointer)
   - Respects prefers-reduced-motion
   ===================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.lcInit === '1') return;
    section.dataset.lcInit = '1';

    var cards = section.querySelectorAll('[data-lc-card]');
    if (!cards.length) return;

    /* Reveal on scroll */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    }

    /* Pointer glow — desktop only */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine || reduceMotion) return;

    cards.forEach(function (card) {
      var media = card.querySelector('.luxury-categories__item-media');
      var glow = card.querySelector('.luxury-categories__item-glow');
      if (!media || !glow) return;

      var rafId = 0;
      var px = 50, py = 50;

      function apply() {
        rafId = 0;
        glow.style.setProperty('--lc-mx', px + '%');
        glow.style.setProperty('--lc-my', py + '%');
      }

      card.addEventListener('pointermove', function (e) {
        var rect = media.getBoundingClientRect();
        px = ((e.clientX - rect.left) / rect.width) * 100;
        py = ((e.clientY - rect.top) / rect.height) * 100;
        if (!rafId) rafId = requestAnimationFrame(apply);
      }, { passive: true });

      card.addEventListener('pointerleave', function () {
        px = 50; py = 50;
        if (!rafId) rafId = requestAnimationFrame(apply);
      }, { passive: true });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-luxury-categories]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
